import React, { FC } from 'react';
import { ReactComponent as AlertTriangleIcon } from '../../icons/alert-triangle-outline.svg';
import type { HandbookSetupAnswers } from './handbookContract';
import { blankSections, blankSectionsMessage } from './handbookSetup';
import './handbook-setup.scss';

interface HandbookBlankPanelProps {
  answers: HandbookSetupAnswers;
}

/** Warns about the pages the setup left blank. Never blocks publishing. */
export const HandbookBlankPanel: FC<HandbookBlankPanelProps> = ({
  answers,
}) => {
  const message = blankSectionsMessage(answers);
  if (!message) return null;
  return (
    <section className='handbook-check warning' data-testid='handbook-check'>
      <div className='handbook-check-row unclear'>
        <AlertTriangleIcon aria-hidden='true' />
        <div>
          <p className='handbook-check-row-text'>{message}</p>
          <ul className='handbook-check-issues'>
            {blankSections(answers).map(({ area, items }) => (
              <li key={area}>
                <strong>{area}:</strong> {items.join(', ')}
              </li>
            ))}
          </ul>
          <p className='handbook-check-row-text handbook-check-next'>
            You can add these later from your Handbook, before or after you
            publish.
          </p>
        </div>
      </div>
    </section>
  );
};
